import {booleanAttribute, ChangeDetectionStrategy, Component, input, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-section-closing-icon',
    imports: [CommonModule],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<svg
    [ngClass]="[
      'rotate-180 transition-all transform',
      active() ? '!rotate-0' : ''
    ]"
    width="30"
    height="30"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5099 20C16.0244 20 20.5 15.52 20.5 10C20.5 4.48 16.0244 0 10.5099 0C4.9953 0 0.519718 4.48 0.519718 10C0.519718 15.52 4.9953 20 10.5099 20ZM10.5099 8L14.5059 12H6.5138L10.5099 8Z"
      class="fill-secondary"
    />
  </svg> `
})
export class SectionClosingIconComponent {
  active = input(false, {transform: booleanAttribute});
}
